export default function (state = {}, action) {
   switch (action.type) {

      case 'GET_DUTY_ROSTER':
         {
            return {
               ...state,
               dutyRosterPayload: action.payload
            };
         }
      case 'GET_DUTY_ROSTER_SHOW':
         {
            return {
               ...state,
               dutyRosterShowPayload: action.payload
            };
         }
      default:
         return state;
   }
}
